module.exports = __webpack_public_path__ + "img/icon-warning-snow-red.645a6422.svg";